import React from 'react';
import { GOD_MODE_ENABLED, GOD_MODE_COOKIE} from "app/config/api-config";
import Cookies from "universal-cookie"
import { projectId } from "app/helpers/api"

import { getFakeProjectId} from "app/helpers/url-params"
class SetCookie extends React.PureComponent<{},{}> {

    constructor(props) {
        super(props)
        if(projectId == parseInt(GOD_MODE_ENABLED)) {
            const cookies = new Cookies()
            cookies.set(GOD_MODE_COOKIE, getFakeProjectId(), { path: '/', sameSite: 'none', secure: true });
            location.href = `/eshop/1/project/${projectId}`
        }
    }

    render() {
        return <div>Cookie set, redirecting...</div>
    }
}

export default SetCookie
